import * as actionTypes from "./actionTypes";

export const afterLogin = (data, navigate) => {
    return async (dispatch) => {
        localStorage.setItem("doe-gyandeep-authdata-admin", JSON.stringify(data))
        localStorage.setItem("DOE-Gyandeep-Token-admin", data.token)
        if (data.user?.role === "district") {
            // navigate("/admin/block-list")
            navigate("/admin/dashboard")
        }
        else if (data.user?.role === "block") {
            // navigate("/admin/school-list")
            navigate("/admin/dashboard")
        }
        else if (data.user?.role === "school") {
            // navigate("/admin/student-list")
            navigate("/admin/dashboard")
        }
        else {
            navigate("/admin/dashboardV2-admin")
        }
        dispatch(updateAuthData(data, data.token))
    };
};

export const onReloadAdmin = () => {
    return async (dispatch) => {
        // dispatch(apiLoading())
        let tokenData = localStorage.getItem("DOE-Gyandeep-Token-admin") ? localStorage.getItem("DOE-Gyandeep-Token-admin") : null
        let token = localStorage.getItem("doe-gyandeep-authdata-admin") ? JSON.parse(localStorage.getItem("doe-gyandeep-authdata-admin")) : null
        if (token) {
            dispatch(updateAuthData(token, tokenData))
        }
    };
};


export const onLogout = (navigate) => {
    return (dispatch) => {

        localStorage.clear();
        dispatch(resetAuth());
        navigate("/");
    }
};




export const updateAuthData = (data, token) => {
    return {
        type: actionTypes.UPDATE_AUTH_DATA,
        payload: { data, token },
    };
};


export const resetAuth = (data) => {
    return {
        type: actionTypes.RESET,
    };
};

export const updateReducer = (key, data) => {
    return {
        type: actionTypes.UPDATE_REDUCER,
        payload: { key, data }
    };
};



